"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types */
Object.defineProperty(exports, "__esModule", { value: true });
class AbstractCache {
    constructor() {
        this.getNumber = (key) => {
            return this.getValue(key);
        };
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.getObject = (key) => {
            return this.getValue(key);
        };
        this.getString = (key) => {
            return this.getValue(key);
        };
        this.getArray = (key) => {
            return this.getValue(key);
        };
        this.setNumber = (key, value) => {
            return this.setValue(key, value);
        };
        this.setObject = (key, 
        // eslint-disable-next-line @typescript-eslint/ban-types
        value) => {
            return this.setValue(key, value);
        };
        this.setString = (key, value) => {
            return this.setValue(key, value);
        };
        this.setArray = (key, value) => {
            return this.setValue(key, value);
        };
    }
}
exports.default = AbstractCache;
//# sourceMappingURL=AbstractCache.js.map